import {
  useMutation,
  useQueryClient,
} from "@tanstack/react-query"

import { api } from "@/api"
import { BASE_URL, ENDPOINTS } from "@/constants"

interface ReverseOrderProps {
  orderId: string
  reason: string
  /**
   * Reverte mesmo que o banco recuse a baixa, falhe ou não responda, e mesmo com o pedido travado
   * em `SUBMITTED_FOR_REVERSED`. Rota separada porque exige superadministrador — no gateway o
   * escopo é por rota, não por parâmetro.
   */
  forced?: boolean
}

/**
 * Reversão de pedido pelo portal.
 *
 * Difere do cancelamento, que vale para pedido ainda pendente: aqui o pedido já saiu do pendente e
 * o que se desfaz é a cobrança.
 */
export const useReverseOrderMutation = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async ({
      orderId,
      reason,
      forced = false,
    }: ReverseOrderProps) => {
      const endpoint = forced
        ? ENDPOINTS.ORDER_FORCED_REVERSAL
        : ENDPOINTS.ORDER_REVERSAL

      await api.put(`${BASE_URL}${endpoint}/${orderId}`, {
        reason,
      })
    },
    onSuccess: async () => {
      // Invalidação por PREFIXO de propósito: a ficha do pedido é `[ORDERS, orderId]` e a listagem
      // é `[ORDER_BY_FILTER, queryString, refetch]` — duas formas distintas sobre a mesma rota
      // ("/orders"). Invalidar com a chave completa da ficha deixaria a listagem exibindo o status
      // antigo, e o botão de reverter continuaria oferecido sobre um pedido já revertido.
      await queryClient.invalidateQueries({
        queryKey: [ENDPOINTS.ORDERS],
      })
      await queryClient.invalidateQueries({
        queryKey: [ENDPOINTS.RECEIVABLE],
      })
    },
  })
}
